import { combineReducers } from 'redux';
import searchResultReducer from './search-result';

const settingsOriginReducer = combineReducers({
  searchResult: searchResultReducer,
});

export default settingsOriginReducer;
